export default "__VITE_ASSET__ajW8m$o$__"